<template>
    <div>
        <div class="container">
            <div class="row mt-5">
                <div class="col-12 text-center mt-5">
                    <h3 class="heading">Featured Artist</h3>
                    <hr class="custom-hr">
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-5">
                    <ul class="nav nav-pills d-flex justify-content-center mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <span class="filter" v-bind:class="{ active: currentFilter === '2013' }" v-on:click="setFilter('2013')">2013</span>
                        </li>
                        <li class="nav-item">
                            <span class="filter" v-bind:class="{ active: currentFilter === '2014' }" v-on:click="setFilter('2014')">2014</span>
                        </li>
                        <li class="nav-item">
                            <span class="filter" v-bind:class="{ active: currentFilter === '2015' }" v-on:click="setFilter('2015')">2015</span>
                        </li>
                        <li class="nav-item">
                            <span class="filter" v-bind:class="{ active: currentFilter === '2016' }" v-on:click="setFilter('2016')">2016</span>
                        </li>
                        <li class="nav-item">
                            <span class="filter" v-bind:class="{ active: currentFilter === '2017' }" v-on:click="setFilter('2017')">2017</span>
                        </li>
                        <li class="nav-item">
                            <span class="filter" v-bind:class="{ active: currentFilter === '2018' }" v-on:click="setFilter('2018')">2018</span>
                        </li>
                        <li class="nav-item">
                            <span class="filter" v-bind:class="{ active: currentFilter === '2020' }" v-on:click="setFilter('2020')">2020</span>
                        </li>
                    </ul>
                    <transition-group class="projects" name="projects" >
                        <template  v-for="project in projects">
                            <div class="project" v-if="currentFilter === project.category" v-bind:key="project.image">
                                <div class="project-image-wrapper">
                                    <img class="project-image" v-bind:src="project.image">
                                    <!-- <div class="gradient-overlay"></div> -->
                                </div>
                                <div class="artist-name">{{ project.name }}</div>
                            </div>
                        </template>
                    </transition-group>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
export default {
    data(){
        return{
             currentFilter: '2020',
              projects: [
                
                {name:"Music",image: require("../assets/images/featured/2013/featuredartist (1).jpg"), category: '2013'},
                {name:"Lucid Recess",image: require("../assets/images/featured/2013/featuredartist (2).jpg"), category: '2013'},
                { name:"Music",image: require("../assets/images/featured/2013/featuredartist (3).jpg"), category: '2013'},
                { name:"Susmit Bose",image: require("../assets/images/featured/2013/featuredartist (4).jpg"), category: '2013'},
                { name:"Kaushik Phookun",image: require("../assets/images/featured/2013/featuredartist (5).jpg"), category: '2013'},
                {name:"Partha Pratim Neog",image: require("../assets/images/featured/2013/featuredartist (6).jpg"), category: '2013'},
                { name:"Still Water",image: require("../assets/images/featured/2013/featuredartist (7).jpg"), category: '2013'},
                {name:"Music",image: require("../assets/images/featured/2013/featuredartist (8).jpg"), category: '2013'},
                {name:"Papon",image: require("../assets/images/featured/2014/featuredartist (1).jpg"), category: '2014'},
                {name:"Warklung",image: require("../assets/images/featured/2014/featuredartist (2).jpg"), category: '2014'},
                {name:"Sukoon",image: require("../assets/images/featured/2014/featuredartist (3).jpg"), category: '2014'},
                {name:"Rewben Mashangva",image: require("../assets/images/featured/2014/featuredartist (4).jpg"), category: '2014'},
                {name:"Tetseo Sisters",image: require("../assets/images/featured/2014/featuredartist (5).jpg"), category: '2014'},
                {name:"Soulmate",image: require("../assets/images/featured/2014/featuredartist (6).jpg"), category: '2014'},
                {name:"Digital Suicide",image: require("../assets/images/featured/2014/featuredartist (7).jpg"), category: '2014'},
                {name:"Street Stories",image: require("../assets/images/featured/2014/featuredartist (8).jpg"), category: '2014'},
                {name:"Imphal Talkies",image: require("../assets/images/featured/2015/featuredartist15 (1).jpg"), category: '2015'},
                {name:"Lama Tashi",image: require("../assets/images/featured/2015/featuredartist15 (2).jpg"), category: '2015'},
                {name:"Dosser's Urge",image: require("../assets/images/featured/2015/featuredartist15 (3).jpg"), category: '2015'},
                {name:"Warklung",image: require("../assets/images/featured/2015/featuredartist15 (4).jpg"), category: '2015'},
                {name:"Purple Fusion",image: require("../assets/images/featured/2015/featuredartist15 (5).jpg"), category: '2015'},
                {name:"Ganesh Talkies",image: require("../assets/images/featured/2015/featuredartist15 (6).jpg"), category: '2015'},
                {name:"The Vinyl Records",image: require("../assets/images/featured/2015/featuredartist15 (7).jpg"), category: '2015'},
                {name:"Your Chin",image: require("../assets/images/featured/2015/featuredartist15 (8).jpg"), category: '2015'},
                {name:"Ambush",image: require("../assets/images/featured/2016/featuredartist (1).jpg"), category: '2016'},
                {name:"Yesterdrive",image: require("../assets/images/featured/2016/featuredartist (2).jpg"), category: '2016'},
                {name:"Ganesh Talkies",image: require("../assets/images/featured/2016/featuredartist (3).jpg"), category: '2016'},
                {name:"Joker's Whoop",image: require("../assets/images/featured/2016/featuredartist (4).jpg"), category: '2016'},
                {name:"Eclipse",image: require("../assets/images/featured/2016/featuredartist (5).jpg"), category: '2016'},
                {name:"Tritha Electric",image: require("../assets/images/featured/2016/featuredartist (6).jpg"), category: '2016'},
                {name:"Ragamaya",image: require("../assets/images/featured/2016/featuredartist (7).jpg"), category: '2016'},
                {name:"Pinknose",image: require("../assets/images/featured/2016/featuredartist (8).jpg"), category: '2016'},
                {name:"Juke Box",image: require("../assets/images/featured/2017/featuredartist (1).jpg"), category: '2017'},
                {name:"Tour Bus",image: require("../assets/images/featured/2017/featuredartist (2).jpg"), category: '2017'},
                {name:"Skylevel",image: require("../assets/images/featured/2018/featuredartist (1).jpg"), category: '2018'},
                {name:"Blue Temptation",image: require("../assets/images/featured/2018/featuredartist (2).jpg"), category: '2018'},
                {name:"Khasi Bloodz",image: require("../assets/images/featured/2018/featuredartist (3).jpg"), category: '2018'},
                {name:"Dewdrops",image: require("../assets/images/featured/2018/featuredartist (4).jpg"), category: '2018'},
                {name:"Arogya",image: require("../assets/images/featured/2018/featuredartist (5).jpg"), category: '2018'},
                {name:"Plague Throat",image: require("../assets/images/featured/2018/featuredartist (6).jpg"), category: '2018'},
                {name:"Dymbur",image: require("../assets/images/featured/2018/featuredartist (7).jpg"), category: '2018'},
                {name:"Lo ! Peninsula",image: require("../assets/images/featured/2018/featuredartist (8).jpg"), category: '2018'},
                {name:"Arkupal Ra Acharya",image: require("../assets/images/featured/2020/13.jpg"), category: '2020'},
                {name:"Gyaan D Bhuyan",image: require("../assets/images/featured/2020/14.jpg"), category: '2020'},
                {name:"Sankalpa Raychaudhury",image: require("../assets/images/featured/2020/15.jpg"), category: '2020'},
                {name:"Saurav Saikia",image: require("../assets/images/featured/2020/16.jpg"), category: '2020'},
                {name:"Sattyakee D'Com Bhuyan",image: require("../assets/images/featured/2020/17.jpg"), category: '2020'},
                
                
            ]
        }
    },
    methods:{
        setFilter: function(filter) {
			this.currentFilter = filter;
		}
    }
}
</script>


<style scoped>
.nav-item{
    margin-bottom: 8px;
}

.filter {
    font-size: 1.6rem;
	font-family:arial;
	padding: 10px 16px;
	cursor:pointer;
	/* border-radius: 3px; */
    
	transition: all 0.35s;
    /* background: #fbd020; */
	/* border: 2px solid transparent; */
	margin-right: 2px;
}
.filter.active, .filter:hover.active {
	/* box-shadow:0px 1px 3px 0px #00000026; */
    background: #4a4a4a;
	color: #fbd020;
	font-weight: bold;
	/* border: 2px solid black; */
}

.filter:hover {
	background:lightgray;
	/* border: 2px solid black; */
} 
.projects {

	margin-bottom:20px;
	margin-top:25px;
	display:flex;
	flex-wrap:wrap;
	justify-content:center;
}

.projects-enter {
	transform: scale(0.5) translatey(-80px);
	opacity:0;
}

.projects-leave-to{
	transform: translatey(30px);
	opacity:0;
}

.projects-leave-active {
	position: absolute;
	z-index:-1;
}

.project {
	background: #fff;
	transition: all .35s ease-in-out;
	margin:10px;
	box-shadow:0px 2px 8px lightgrey;
	border-radius:3px;
	width:250px;
	height:240px;
	display:flex;
	flex-direction:column;
	align-items:center;
}
.project-image-wrapper {
	position:relative;
    width: 100%;
    height: 200px;
    /* height: 100%; */
    padding: 0px 2px;
}
.project-image {
	width:100%;
	/* height:150px; */
    height: 100%;
	border-bottom-left-radius:5px;
	border-bottom-right-radius:5px;
	border-top-left-radius:3px;
	border-top-right-radius:3px;
}

.artist-name{
    /* font-family: Nothing You Could Do; */
    font-size: 1.6rem;
    font-weight: 600;
    margin: 6px 0px;
}
@media (max-width: 768px){
    .project{
        /* width: 14.4rem; */
        width: 50%;
        /* height: 21.5rem; */
        height: auto;
        margin: 5px 0px;
    }
    .artist-name{
        margin:3px 0px;
    }
    .project-image-wrapper{
        /* height: 18.5rem; */
        height: auto;
    }
    .project-image{
        object-fit: cover;
        object-position: center;
    }
    .filter{
        font-size: 1.5rem;
        padding: 7px 10px;
    }
}
</style>
